import { trackClientEvent } from '../../../../trackClientEvent';
import { ITraceEventMarker } from '@faire/web--source/common/pete/TraceEventTracker';

export const eventKey =
  'faire_direct-marketplace_incentive_banner_view_details-click';

/**
 * Tracks when the Faire Direct marketplace banner &quot;View details&quot; button is clicked.
 */
export function trackFaireDirectMarketplaceIncentiveBannerViewDetailsClick(
  retailerToken: string,
  type: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    parameters: { retailerToken, type },
  });
}
